export const CLEANUP_OAUTH_PAGE_STATE = 'cleanup-oauth-page-state';
const cleanupOAuthPageState = () => ({ type: CLEANUP_OAUTH_PAGE_STATE });
export default cleanupOAuthPageState;
